<template>
  <div class="vue-rqf-page">
    <div style="background-color: #ccc; height:500px;"></div>
  </div>
</template>

<script>

export default {
  data () {
    return {}
  }
}
</script>

<style lang="scss">

</style>


// WEBPACK FOOTER //
// AutoOffer.vue?46287ce8